'use client';

import { c as _c } from "react/compiler-runtime";
import { SidebarMenuItem } from '@repo/ui/components';
import { ThemeSwitcher } from '@repo/ui/components/kibo/theme-switcher';
import { useTheme } from '@repo/ui/providers';
const THEME_VALUES = ['dark', 'light', 'system'] as const;
export const SidebarThemeToggle = () => {
  const $ = _c(6);
  const {
    setTheme,
    theme
  } = useTheme();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="text-sm text-sidebar-foreground">Theme</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== theme) {
    t1 = THEME_VALUES.find(value => value === theme);
    $[1] = theme;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== setTheme || $[4] !== t1) {
    t2 = <SidebarMenuItem className="flex items-center justify-between group-data-[collapsible=icon]:hidden" data-sentry-element="SidebarMenuItem" data-sentry-component="SidebarThemeToggle" data-sentry-source-file="sidebar-theme-toggle.tsx">{t0}<ThemeSwitcher defaultValue="system" onChange={setTheme} value={t1} data-sentry-element="ThemeSwitcher" data-sentry-source-file="sidebar-theme-toggle.tsx" /></SidebarMenuItem>;
    $[3] = setTheme;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};